import { render, staticRenderFns } from "./HomeLive101Trainings.vue?vue&type=template&id=2533c96b&scoped=true&"
import script from "./HomeLive101Trainings.vue?vue&type=script&lang=js&"
export * from "./HomeLive101Trainings.vue?vue&type=script&lang=js&"
import style0 from "./HomeLive101Trainings.vue?vue&type=style&index=0&id=2533c96b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2533c96b",
  null
  
)

export default component.exports